<template>
  <div class="pc-wrapping">
    <!-- 头部 -->
    <div class="pc-header">
      <!-- logo -->
      <div class="pc-logo">
        <el-image :src="logoUrl"> </el-image>
      </div>
    </div>

    <!-- 底图 -->
    <div class="pc-main-image"></div>

    <!-- 内容 -->
    <div class="pc-content">
      <!-- home-内容 -->
      <div class="pc-content-home">
        <!-- 支付 -->
        <div class="pc-payment">
          <el-card
            :body-style="{ padding: '0px', border: '0px' }"
            class="pc-payment-main-image"
          >
            <div class="pc-payment-user-info">
              <el-row
                :gutter="2"
                align="middle"
                class="pc-payment-user-info-row"
              >
                <el-col :span="6">
                  <div>
                    <el-avatar
                      :size="90"
                      :src="userInfo.avatar"
                      class="user-info-avatar"
                    ></el-avatar>
                  </div>
                </el-col>

                <el-col :span="4">
                  <div class="user-info">
                    <div>NickName:</div>
                    <div>User ID:</div>
                    <div>Package:</div>
                  </div>
                </el-col>

                <el-col :span="8">
                  <div class="user-info">
                    <div>{{ userInfo.nickname }}</div>
                    <div>{{ userInfo.uid }}</div>
                    <div>{{ productInfo.diamond }} Diamonds</div>
                  </div>
                </el-col>

                <el-col :span="6" class="return">
                  <el-button @click="back" type="text" el-icon-question
                    >&lt; Return</el-button
                  >
                </el-col>
              </el-row>
            </div>

            <div class="pc-payment-divider"></div>

            <div class="pc-payment-result">
              <el-row>
                <div class="pc-payment-result-msg">
                  <i
                    class="el-alert__icon el-icon-success"
                    v-if="isSuccess === 'true'"
                  />
                  <i class="el-alert__icon el-icon-error" v-else />
                  <span class="msg-content">{{ msg }}</span>
                </div>
              </el-row>

              <!-- 价格 -->
              <el-row>
                <div class="pc-payment-price">
                  <span v-if="productInfo.price"
                    >Amount: {{ productInfo.price }} USD</span
                  >
                </div>
              </el-row>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="pc-footer">
      <div class="pc-footer-info">
        <x-foot/>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/home/pc/logo.png'
import productConfig from '@/util/product'
import { userInfo } from '@/api/user'
import foot from '@/views/components/foot'

export default {
  name: 'PaymentResultPc',
  components: {
    'x-foot': foot
  },
  props: {
    msg: {
      type: String,
      default: 'success',
      required: true
    },
    isSuccess: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      logoUrl: logo,
      userInfo: {
        uid: '',
        nickname: '',
        avatar: ''
      },
      productList: [],
      productInfo: {
        diamond: '',
        price: '',
        productId: ''
      }
    }
  },
  mounted () {
    let query = this.$route.query || {}
    this.productList = productConfig

    this.productInfo.productId = query.productId || ''
    this.productInfo = this.getProduct(this.productInfo.productId)

    if (!query.uid) {
      this.$router.push({ name: 'Recharge' })
    } else {
      let avatar = ''
      let userInfos = JSON.parse(window.localStorage.getItem('userinfos')) || {}
      if (userInfos[query.uid]) {
        this.userInfo.uid = query.uid
        this.userInfo.nickname = userInfos[query.uid].nickname || ''
        avatar = userInfos[query.uid].avatar || ''
        this.avatarHandle(avatar)
      } else {
        userInfo({uid: query.uid})
          .then(({ data }) => {
            if (data.uid) {
              let userInfos = JSON.parse(window.localStorage.getItem('userinfos')) || {}
              userInfos[data.uid] = data
              window.localStorage.setItem('userinfos', JSON.stringify(userInfos))
              this.userInfo.uid = data.uid
              this.userInfo.nickname = data.nickname || ''
              avatar = data.avatar || ''
              this.avatarHandle(avatar)
            } else {
              this.$message({
                showClose: true,
                message: 'User not found',
                type: 'error'
              })
            }
            this.submitBtnDisable = false
          })
          .catch(() => {
            this.$message({
              showClose: true,
              message: 'Server err',
              type: 'error'
            })
            this.submitBtnDisable = true
          })
      }
    }
  },
  methods: {
    back () {
      this.$router.push({ name: 'Recharge' })
    },
    avatarHandle (userAvatar) {
      let avatar = 'none.jpg'
      if (userAvatar.startsWith('http')) {
        this.userInfo.avatar = userAvatar
      } else if (userAvatar) {
        let subfix = '.jpg'
        const avatars = userAvatar.split(':')
        if (userAvatar.startsWith('default')) {
          avatar = avatars[1] + subfix
        } else if (userAvatar.startsWith('special')) {
          subfix = '.png'
          avatar = avatars[1] + subfix
        }
        this.userInfo.avatar = require('@/assets/images/avatar/user/player_head_' + avatar)
      }
    },
    getProduct (productId) {
      let product = {}
      this.productList.forEach((item) => {
        if (item.productId === productId) {
          product = item
        }
      })
      return product
    }
  }
}
</script>

<!-- 覆盖样式 -->
<style>
.pc-payment .el-card {
  border: 0px;
}

.user-info-avatar {
  border: groove 2px #5786bf; /* no*/
}
</style>

<style scoped>
.pc-wrapping {
  background: url("~@/assets/images/recharge/pc/backgourp_image.jpg") repeat-x;
  position: fixed;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  min-width: 1024px; /* no*/
  min-height: 768px; /* no*/
} /* no*/

.pc-header {
  width: 300px; /* no*/
  display: -webkit-flex;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;

  margin-top: 50px;
} /* no*/

.pc-logo {
  width: 270px; /* no*/
  height: 70px; /* no*/
  -webkit-flex: 1;
  flex: 1;
} /* no*/

.pc-main-image {
  width: 46%;
  margin: 0 auto;
} /* no*/

.pc-payment {
  width: 100%; /* no*/
  height: 540px; /* no*/
  display: flex;
  align-content: center;
  justify-content: center;
}

.pc-payment-main-image {
  background: url("~@/assets/images/recharge/pc/backgourp-payment-main.png")
    center center no-repeat;
  opacity: 0.8;
  width: 719px; /* no*/
  height: 538px; /* no*/
}

.pc-payment-user-info {
  height: 156px; /* no*/
}

.pc-payment-user-info-row {
  height: 156px; /* no*/
  justify-content: center;
  align-items: center;
  display: -webkit-flex;
}

.pc-payment-user-info .user-info {
  float: left;
  text-align: left;
  color: #ffffff;
}

.pc-payment-user-info .user-info div {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px; /* no*/
  font-weight: normal;
  font-stretch: normal;
  line-height: 32px; /* no*/
  letter-spacing: 0px; /* no*/
  color: #ffffff;
}

.pc-payment-user-info .return {
  height: 76%;
  align-items: start;
}

.pc-payment-price {
  font-family: SourceHanSansCN-Regular;
  font-size: 24px; /* no*/
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px; /* no*/
  letter-spacing: 0px;
  color: #ffffff;
}

.pc-payment-result {
  height: 140px; /* no*/
  line-height: 140px; /* no*/
}

.pc-payment-result .pc-payment-result-msg .el-icon-success {
  font-size: 34px; /* no*/
  width: 40px; /* no*/
  color: #32c77e;
}

.pc-payment-result .pc-payment-result-msg .el-icon-error {
  font-size: 34px; /* no*/
  width: 40px; /* no*/
  color: #f56c6c;
}

.pc-payment-result .pc-payment-result-msg .msg-content {
  font-family: SourceHanSansCN-Regular;
  font-size: 34px; /* no*/
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px; /* no*/
  letter-spacing: 0px;
  color: #ffffff;
}

.pc-payment-divider {
  background: url("~@/assets/images/recharge/pc/payment-divider.png") center
    center no-repeat;
  width: 100%;
  height: 2px; /* no*/
}

.pc-main-image {
  background: url("~@/assets/images/recharge/pc/backgourp_main.png") center
    bottom no-repeat;
  opacity: 0.5;
  min-width: 571px; /* no*/
  min-height: 786px; /* no*/
  width: 100%;
  position: fixed;
  bottom: 10px; /* no*/
  display: flex;
  align-content: center;
  justify-content: center;
} /* no*/

.pc-footer {
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 30px; /* no*/
  display: flex;
  align-content: center;
  justify-content: center;
} /* no*/

.pc-footer-info {
  width: 100%;
  height: 28px;
  font-size: 12px; /* no*/
  font-weight: normal;
  font-stretch: normal;
  line-height: 19px; /* no*/
  letter-spacing: 0px;
  color: #d2d7e5;
} /* no*/

.pc-footer-info a {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/components/result/pc.vue